import createContext from '@ant-design/create-react-context';
var RowContext = createContext({});
export default RowContext;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/grid/RowContext.js
// module id = 318
// module chunks = 0